import {
  Currency,
  type CurrencyConstructor,
} from '@webapp/core/entities/external/Currency'

export interface AssignedCreditCardConstructor {
  id: number
  name: string
  number: string
  type: Nullable<number>
  currency: CurrencyConstructor
}

export class AssignedCreditCard {
  readonly id: number
  readonly name: string
  readonly number: string
  readonly type: Nullable<number>
  readonly currency: Currency

  constructor(data: AssignedCreditCardConstructor) {
    this.id = data.id
    this.name = data.name
    this.number = data.number
    this.type = data.type
    this.currency = new Currency(data.currency)
  }

  get displayLabel(): string {
    return `${this.name} ${this.number}`
  }
}
